/**
 * Helper para obter ou criar um clientId anônimo persistente no localStorage.
 * Utilizado para controle e limite de uso da funcionalidade de Correção de Redações por IA.
 */
export function getOrCreateClientId(): string {
  const KEY = "tef_client_id";
  try {
    const existing = localStorage.getItem(KEY);
    if (existing) {
      return existing;
    }

    // Cria id único no formato client_[timestamp]_[rand_string]
    const timestamp = Math.floor(Date.now() / 1000);
    const rand = Math.random().toString(36).substring(2, 10);
    const newId = `client_${timestamp}_${rand}`;

    localStorage.setItem(KEY, newId);
    return newId;
  } catch (error) {
    console.error("Erro ao ler/gravar o clientId do localStorage:", error);
    return "anonymous_local_client";
  }
}
